module.exports = __webpack_public_path__ + "static/img/title.0c62df8c.png";